import { statusMeta, REASON_LABELS } from "@/lib/labels";

export function StatusBadge({ code, reasons = [], size = "sm" }) {
  const m = statusMeta(code);
  const pad = size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs";
  const why = code === "DIFERENCIA" && reasons && reasons.length
    ? reasons.map((r) => REASON_LABELS[r] || r).join(", ")
    : null;
  return (
    <span
      data-testid={`status-badge-${code}`}
      title={why ? `Diferencia en: ${why}` : m.label}
      className={`inline-flex items-center rounded-sm font-semibold whitespace-nowrap border ${pad}`}
      style={{ background: m.bg, color: m.text, borderColor: m.border }}
    >
      {m.label}
      {why && <span className="ml-1 font-medium opacity-80">· {why}</span>}
    </span>
  );
}

export function ReasonChips({ reasons = [] }) {
  if (!reasons.length) return <span className="text-slate-300">—</span>;
  return (
    <div className="flex flex-wrap gap-1">
      {reasons.map((r) => (
        <span key={r}
          className="inline-flex items-center rounded-sm bg-[#FEE2E2] text-[#991B1B] border border-[#F87171] px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          {REASON_LABELS[r] || r}
        </span>
      ))}
    </div>
  );
}
